<template>
  <v-app>
    <div class="bg"></div>
    <div class="bg-overlay"></div> <!-- overlay nova -->

    <v-main>
      <v-container
        class="d-flex align-center justify-center"
        style="min-height: 100vh;"
      >
        <v-row justify="center" align="center" class="w-100">
          <v-col cols="12" sm="10" md="8" lg="6" xl="5">
            <v-card elevation="12" class="premium-login-card glass">
              <h1 class="h1 pb-8 text-center text-white">Bem vindo de volta</h1>

              <v-form @submit.prevent="submit">
                <v-row>
                  <v-col cols="12" md="6" offset-md="3" class="text-center">
                    <a
                      href="#"
                      @click.prevent="loginModal = true"
                      class="text-link"
                    >
                      Credenciais
                    </a>
                  </v-col>
                </v-row>
              </v-form>

              <div class="d-flex justify-center mt-12">
                <span class="powered text-white">
                  Powered By <a target="_blank" href="https://www.dreamdealtech.pt/">Dreamdeal Technologies</a>
                </span>
              </div>
            </v-card>
          </v-col>
        </v-row>

      </v-container>
    </v-main>

    <!-- Premium Login Modal -->
    <v-dialog
      v-model="loginModal"
      :max-width="smAndDown ? '100%' : 520"
      scrollable
    >
      <v-card class="premium-modal-card">
        <v-card-title class="premium-modal-header">
          <div class="modal-header-content">
            <div class="modal-icon">
              <v-icon size="24" color="white">mdi-account-key</v-icon>
            </div>
            <span class="modal-title"></span>
          </div>
          <v-btn 
            variant="text" 
            @click="loginModal = false"
            class="close-btn"
            icon
          >
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="premium-modal-content">
          <v-form @submit.prevent="submit">
            <v-text-field
              v-model="username"
              label="Email\Username"
              prepend-inner-icon="mdi-account"
              autocomplete="off"
              variant="outlined"
              class="premium-input"
              color="primary"
              :disabled="isSubmitting"
            ></v-text-field>
            <v-text-field
              v-model="password"
              label="Password"
              autocomplete="off"
              prepend-inner-icon="mdi-lock"
              variant="outlined"
              class="premium-input"
              color="primary"
              type="password"
              :disabled="isSubmitting"
            ></v-text-field>
            <v-btn
              type="submit"
              color="success"
              class="premium-submit-btn"
              block
              size="large"
              variant="elevated"
              :disabled="!password || !username || this.isSubmitting"
            >
              <v-icon start>{{ this.isSubmitting ? 'mdi-loading mdi-spin' : 'mdi-login' }}</v-icon>
              {{ this.isSubmitting ? 'Iniciando sessão...' : 'Login' }}
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Reset Password Modal -->
    <v-dialog
      v-model="reset_password.opened"
      max-width="600px"
      class="premium-dialog"
    >
      <v-card class="premium-modal-card">
        <v-card-title class="premium-modal-header">
          <div class="modal-header-content">
            <div class="modal-icon">
              <v-icon size="24" color="white">mdi-lock-reset</v-icon>
            </div>
            <span class="modal-title">Reset Password</span>
          </div>
          <v-btn 
            variant="text" 
            @click="reset_password.opened = false"
            class="close-btn"
            icon
          >
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="premium-modal-content">
          <v-form v-if="!reset_password.reseted" ref="resetForm" v-model="resetFormValid" @submit.prevent="reset">
            <v-text-field
              v-model="reset_password.email"
              prepend-inner-icon="mdi-at"
              label="Email"
              type="email"
              variant="outlined"
              class="premium-input"
              color="primary"
              clearable
              :rules="[rules.required, rules.email]"
              :error-messages="resetEmailError ? [resetEmailError] : []"
            />
            <v-btn
              type="submit"
              color="primary"
              class="premium-submit-btn mt-4"
              block
              size="large"
              variant="elevated"
              :disabled="!resetFormValid"
            >
              <v-icon start>mdi-email-send</v-icon>
              Enviar email
            </v-btn>
          </v-form>
          <div v-else class="success-section text-center">
            <div class="success-icon mb-4">
              <v-icon size="64" color="success">mdi-check-circle</v-icon>
            </div>
            <h3 class="success-title mb-3">Email enviado!</h3>
            <p class="success-text">
              Verifique sua caixa de entrada para as instruções de recuperação.
            </p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>


  </v-app>
</template>
<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

/* Premium Login Card */
.premium-login-card {
  border-radius: 32px !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 
    0 32px 80px rgba(0, 0, 0, 0.3),
    0 0 0 1px rgba(255, 255, 255, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  font-family: 'Inter', sans-serif;
  max-width: 500px;
  margin: 0 auto;
  padding: 40px 32px;
  animation: slideUp 1s ease-out;
  transform-style: preserve-3d;
  position: relative;
  overflow: hidden;
}

.premium-login-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, 
    rgba(255, 255, 255, 0.1) 0%, 
    rgba(255, 255, 255, 0.05) 50%,
    rgba(255, 255, 255, 0.02) 100%);
  pointer-events: none;
  border-radius: 32px;
}

.text-link{
  color: rgba(255, 255, 255, 0.411) !important; 
  opacity: 0.9; 
  text-decoration: underline; 
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(40px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Microsoft Button Premium Style */
.microsoft-btn {
  height: 56px !important;
  font-size: 1rem !important;
  letter-spacing: 0.5px !important;
  text-transform: none !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border-radius: 16px !important;
}

.microsoft-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2) !important;
}

/* Premium Modal Styles */
.premium-dialog :deep(.v-overlay__content) {
  animation: modalSlideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.premium-dialog :deep(.v-overlay__scrim) {
  background: rgba(0, 0, 0, 0.6) !important;
  backdrop-filter: blur(8px);
}

.premium-modal-card {
  border-radius: 24px !important;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.897);
  box-shadow: 0 24px 80px rgba(17, 27, 45, 0.15);
  border: 1px solid rgba(17, 27, 45, 0.08);
  font-family: 'Inter', sans-serif;
}

.premium-modal-header {
  background: linear-gradient(135deg, #111b2d 0%, #29334b 100%) !important;
  color: white !important;
  padding: 24px 32px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  position: relative;
  overflow: hidden;
}

.premium-modal-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, 
    rgba(255, 255, 255, 0.1) 0%, 
    rgba(255, 255, 255, 0.05) 100%);
  pointer-events: none;
}

.modal-header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
  z-index: 2;
}

.modal-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.1) 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.modal-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  position: relative;
  z-index: 2;
}

.close-btn {
  background: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 12px;
  width: 44px;
  height: 44px;
  position: relative;
  z-index: 2;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  transform: rotate(90deg);
}

.premium-modal-content {
  padding: 32px !important;
}

.premium-input {
  margin-bottom: 20px;
}

.premium-input :deep(.v-field) {
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(17, 27, 45, 0.08);
  border: 2px solid rgba(17, 27, 45, 0.06);
  transition: all 0.3s ease;
}

.premium-input :deep(.v-field--focused) {
  border-color: rgb(var(--v-theme-primary));
  box-shadow: 0 8px 24px rgba(17, 27, 45, 0.12);
  transform: translateY(-2px);
}

.premium-submit-btn {
  border-radius: 16px !important;
  font-weight: 600 !important;
  font-size: 1rem !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  height: 56px !important;
}

.premium-submit-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2) !important;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(40px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Success Section */
.success-section {
  padding: 20px 0;
}

.success-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: rgb(var(--v-theme-success));
  margin: 0;
}

.success-text {
  font-size: 1rem;
  color: rgba(17, 27, 45, 0.7);
  line-height: 1.6;
  margin: 0;
}

.borred {
  background-color: rgba(125, 125, 125, 0.70) !important;
  color: #000 !important;
}
 .text-white input {
    color: white !important;
  }
.text-white label {
  color: white !important;
}
.text-white i {
  color: white !important;
}
.text-white v-messages__wrapper{
  color: white !important;
}
.bg {
    width: 100%;
    height: 100%;
    position: absolute;
    opacity: 1;
    top: 0;
    left: 0;
    background-size: contain;
}


/* Responsive adjustments */
@media (max-width: 768px) {
  .premium-login-card {
    margin: 16px;
    padding: 32px 24px;
    border-radius: 24px !important;
  }
}

@media (max-width: 480px) {
  .premium-login-card {
    margin: 12px;
    padding: 24px 16px;
    border-radius: 20px !important;
  }
}
</style>
<script>
import User from "@/api/User.js"
import { useDisplay } from 'vuetify'
import axios from 'axios'
import BaseApi from '@/api/BaseApi'
import keycloak from "@/keycloak.js";
export default {
  setup () {
    const { smAndDown } = useDisplay();
    // const isSubmitting = false;
    return { smAndDown, /* isSubmitting */ }
  },
  data: () => ({
    username: "",
    password: "",
    loginModal: false,
    isSubmitting : false,
    reset_password: {
      opened: false,
      email: "",
      reseted: false,
    },
    error:{
      show: false,
      message: ''
    }
  }),
  beforeCreate() {
    document.title = "Nexus - Login";

    if (keycloak.authenticated) {
        this.$router.replace("/admin");

        return;
    }

    keycloak.login({
        redirectUri: window.location.origin + "/admin",
    });

  },
  async mounted() {
    const dbg = new URLSearchParams(window.location.search).has('debug')
    if (dbg) {
      const apiBase = (process.env.VUE_APP_API_URL || '').replace(/\/+$/, '')
      console.group('🔎 ENV / API CHECK')
      console.log('VUE_APP_API_URL =', apiBase)
      console.log('axios.defaults.baseURL =', axios.defaults.baseURL)
      console.log('BaseApi.getApiUrl() =', typeof BaseApi?.getApiUrl === 'function' ? BaseApi.getApiUrl() : null)
      console.groupEnd()
    }


    const cookie = this.$cookies.get('cookie');
    if (cookie == null) this.showCookieBar = true;
  },
  methods:{
    // async forceLogout(){
    //   try {
    //     // 1. Logout no backend Laravel
    //     await User.logout(this.$session?.id ?? null);
    //   } catch (e) {
    //     // mesmo que falhe, seguimos
    //   }

    //   // 2. Limpar cookies visíveis via JS
    //   document.cookie.split(";").forEach(cookie => {
    //     const eqPos = cookie.indexOf("=");
    //     const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    //     document.cookie = name.trim() + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
    //   });
    // },
    // submit () {
    //   if (!this.username || !this.password) return
    //   this.isSubmitting = true;
    //   User.logout()
    //     .then(() => { this.login() })
    //     .catch(() => { this.login() })
    //     .finally(() => {})
    // },
    // login(){
    //   this.isSubmitting = true;
    //   let pwd = this.$encryptValue(this.password);
    //   User.login(this.username, pwd)
    //     .then(({data}) => {

    //         if(data.two_factor){
    //           this.$router.push('/2fa');

    //           return;
    //         }

    //         localStorage['auth'] = 1;
    //         // Obter a rota para redirecionar após o login ou redirecionar para a página padrão '/admin'
    //         let redirectPath = localStorage.getItem('redirectTo') || '/admin';

    //         // Se o user estiver à espera de registar QR Code, deve ir para a rota do qrcode-register
    //         if(localStorage['qrcode-register'] != undefined){
    //           redirectPath = localStorage['qrcode-register'];
    //           localStorage.removeItem('qrcode-register');
    //         }


    //         // Redirecionar para a página de destino
    //         this.$router.push(redirectPath);

    //         // Limpar o valor de 'redirectTo' após o login
    //         localStorage.removeItem('redirectTo');
    //         localStorage.removeItem('refreshDone'); // <-- limpa flag
    //     }).catch(err => {

    //       if(err.response.status == 422) {

    //         this.$refs.login.setErrors(err.response.data.errors);

    //         return;
    //       }

    //       if(err.response.status == 403){
    //         this.error.message = "A sua conta parece estar bloqueada. Entre em contacto com a equipa de suporte!"

    //         this.error.show = true
            
    //       }else{
    //         this.error.message = "Login inválido. Por favor verifique o seu username e password e volte a tentar"

    //         this.error.show = true
    //       }
    //   }).finally(() => {
    //     this.isSubmitting = false
    //   });
    // },
    // reset () {
    //   this.$refs.reset.validate().then((valid) => {
    //     if (!valid) {
    //       return;
    //     }

    //     User.reset(this.reset_password.email)
    //       .then(() => {

    //           this.reset_password.reseted = true;
    //       }).catch(err => {

    //         if(err.response.status == 422) {

    //           this.$refs.reset.setErrors(err.response.data.errors);

    //           return;
    //         }

    //         this.reset_password.reseted = false;

    //     });
    //   });
    // },
  },
};
</script>
<style scopde>
.primary-no-css{
  background-color: #111b2d
}
:root{
  --brand-orange: #E57200;
  --on-dark: #ffffff;
  --glass-bg: rgba(0,0,0,.28);
}

/* fundo com contain + cor exata da marca */
.bg{
  position: fixed; inset: 0; z-index: 0;
  background-size: contain;
}

/* overlay para contraste: vignette + darken subtil no centro */
.bg-overlay{
  position: fixed; inset: 0; z-index: 1;
  pointer-events: none;
  background:
    radial-gradient(1200px 600px at 60% 40%, rgba(0,0,0,0.35), transparent 70%) /* por trás do card */,
    linear-gradient(0deg, rgba(0,0,0,0.10), rgba(0,0,0,0.10)); /* escurece geral 10% */
}

/* card com glassmorphism consistente */
.premium-login-card.glass{
  position: relative; z-index: 2;
  border-radius: 28px !important;
  background: var(--glass-bg) !important;
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border: 1px solid rgba(255,255,255,.22);
  box-shadow:
    0 32px 80px rgba(0,0,0,.35),
    inset 0 1px 0 rgba(255,255,255,.2);
  padding: 40px 32px;
}

/* tipografia/utilitários */
.text-white{ color: var(--on-dark) !important; }
.text-link{ color: var(--on-dark); opacity:.9; text-decoration: underline; }
.text-link:hover{ opacity:1; }

/* botão microsoft estilo “white pill” com ícone escuro */
.microsoft-btn{
  height: 56px !important;
  background: #ffffff !important;
  color: #111 !important;
  border-radius: 16px !important;
  text-transform: none !important;
  font-weight: 700 !important;
  box-shadow: 0 10px 26px rgba(0,0,0,.18) !important;
  transition: transform .2s ease, box-shadow .2s ease !important;
}
.microsoft-btn:hover{ transform: translateY(-2px); box-shadow: 0 16px 36px rgba(0,0,0,.24) !important; }
.microsoft-btn .v-icon{ color:#111 !important; }

/* logout discreto */
.logout-btn{
  background: rgba(255,255,255,.9) !important;
  color: #111 !important;
  border-radius: 999px !important;
}

/* powered */
.powered a{ color:#fff; text-decoration: underline; }

/* foco acessível em botões/links */
.v-btn:focus-visible, a:focus-visible{
  outline: 3px solid #fff; outline-offset: 3px;
  box-shadow: 0 0 0 4px rgba(0,0,0,.35) !important;
}

/* mobile – menos blur e sombras */
@media (max-width: 768px){
  .premium-login-card.glass{
    padding: 28px 22px;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    box-shadow: 0 22px 50px rgba(0,0,0,.28);
  }

  /* a imagem pode saltar para cover em ecrãs estreitos */
  .bg{ background-size: cover; }
}

/* reduzir movimento para quem preferir */
@media (prefers-reduced-motion: reduce){
  .premium-login-card.glass{ animation: none !important; }
}

</style>